import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import ExpiryLink from '../images/svg/Link-ExpiryImg.svg';

export default function NotFound() {
  const { pathname } = useLocation();
  const isShortLink = /^\/(c|p)(\/|$)/.test(pathname);

  if (isShortLink) {
    return (
      <Box
        sx={{
          minHeight: '92vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          py: 6,
          background: 'linear-gradient(180deg, #F7FCFB 0%, #EEF4F8 100%)',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 520,
            overflow: 'hidden',
            textAlign: 'center',
            px: { xs: 3, sm: 6 },
            py: { xs: 4, sm: 5 },
            borderRadius: '24px',
            border: '1px solid',
            borderColor: 'custom.backgroundBorder',
            boxShadow: '0 24px 60px rgba(79, 108, 141, 0.14)',
          }}
        >
          {/* <Box
            sx={{
              position: 'absolute',
              top: -90,
              right: -70,
              width: 200,
              height: 200,
              borderRadius: '50%',
              bgcolor: 'custom.secondaryBlue',
              opacity: 0.8,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: -70,
              left: -50,
              width: 140,
              height: 140,
              borderRadius: '50%',
              bgcolor: 'custom.secondaryGreen',
              opacity: 0.35,
            }}
          /> */}
          <Box sx={{ position: 'relative' }}>
            <Box
              component="img"
              src={ExpiryLink}
              alt="Link expired"
              sx={{ width: { xs: 160, sm: 200 }, height: 'auto', mb: 1 }}
            />
            <Typography
              variant="h4"
              sx={{ color: 'custom.primaryBlue', fontWeight: 700, mb: 1 }}
            >
              Link Expired
            </Typography>
            <Typography
              sx={{
                color: 'custom.primaryTextGrey',
                fontSize: '0.98rem',
                lineHeight: 1.7,
                mb: 3,
              }}
            >
              This link is no longer available.
            </Typography>
            <Button
              component={Link}
              to="/"
              variant="contained"
              sx={{
                bgcolor: 'custom.primaryGreen',
                color: 'white',
                px: 4,
                py: 1.1,
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 8px 20px rgba(56, 207, 171, 0.35)',
                '&:hover': {
                  bgcolor: 'custom.primaryBlue',
                  color: 'white',
                  boxShadow: '0 10px 24px rgba(79, 108, 141, 0.3)',
                },
              }}
            >
              Go to Home
            </Button>
          </Box>
        </Paper>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      textAlign="center"
    >
      <Typography variant="h2" color="primary" gutterBottom sx={{color:"custom.primaryBlue"}}>
        404
      </Typography>
      <Typography variant="h5" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={3}>
        Sorry, the page you are looking for does not exist or has been moved.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        sx={{
          bgcolor: "custom.primaryGreen",
          color: "white",
          '&:hover': {
            bgcolor: 'custom.primaryBlue',
            color: 'white',
          },
        }}
      >
        Go to Home
      </Button>
    </Box>
  );
}
